import { render, staticRenderFns } from "./SalesPersonalStats.vue?vue&type=template&id=5dffa8a8&scoped=true&"
import script from "./SalesPersonalStats.vue?vue&type=script&lang=js&"
export * from "./SalesPersonalStats.vue?vue&type=script&lang=js&"
import style0 from "./SalesPersonalStats.vue?vue&type=style&index=0&id=5dffa8a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffa8a8",
  null
  
)

export default component.exports